import {css, } from 'lit';

export const tabMenuOnDarkStyles = css`
    --_tab-menu__fade-color: var(--sbkBannerBoxColorBgColorEmphasised);
`;